import React from "react";

export default function SucessfullyPublished() {
  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess" style={{ minHeight: "200px" }}>
        <div className="d-flex justify-content-center align-items-center">
          <img src="/HwImg/sucessIcon.png" alt="" />
        </div>
        <div className="d-flex justify-content-center align-items-center mt-4 sucessMsg1">
          Study Planner Successfully Created
        </div>
        <div className="d-flex justify-content-center align-items-center mt-3">
          <button
            className="okayBtnsucess"
            onClick={() => {
              window.location.reload();
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
